import $ from 'jquery';

import { isMaxTablet } from 'chairisher/util/mediaquery';

/**
 * View that encapsulates functionality related to folder the settings menu
 *
 * @param {Object} settings
 * @param {jQuery} settings.$deactivateTriggerEl jQuery element that triggers a deactivation confirmation
 * @param {jQuery} settings.$menuEl jQuery element representing the menu
 * @param {jQuery} settings.$menuTriggerEls jQuery elements that toggle the menu's visibility
 * @param {number} settings.collectionId The id of the collection this menu is for
 * @param {string} settings.deactivateUrl The URL to POST to to deactivate the folder
 *
 * @class FolderMenuView
 * @constructs FolderMenuView
 */
const FolderMenuView = function FolderMenuView(settings) {
    const options = $.extend(
        {
            $deactivateTriggerEl: this.$deactivateTriggerEl,
            $menuEl: this.$menuEl,
            $menuTriggerEls: this.$menuTriggerEls,
            collectionId: this.collectionId,
            deactivateUrl: this.deactivateUrl,
        },
        settings,
    );

    this.$deactivateTriggerEl = options.$deactivateTriggerEl;
    this.$menuEl = options.$menuEl;
    this.$menuTriggerEls = options.$menuTriggerEls;

    this.collectionId = options.collectionId;
    this.deactivateUrl = options.deactivateUrl;

    this.bind();
};

/**
 * Static factory method to create a new FolderMenuView instance.
 *
 * @param {Object} settings - Configuration options for the FolderMenuView.
 * @returns {FolderMenuView} A new FolderMenuView instance.
 */
FolderMenuView.create = (settings) => new FolderMenuView(settings);

/**
 * jQuery element that, when pressed, triggers a deactivation confirmation
 *
 * @type {jQuery}
 */
FolderMenuView.prototype.$deactivateTriggerEl = null;

/**
 * jQuery element representing the menu
 *
 * @type {jQuery}
 */
FolderMenuView.prototype.$menuEl = null;

/**
 * jQuery elements that toggle the menu's visibility
 *
 * @type {jQuery}
 */
FolderMenuView.prototype.$menuTriggerEls = null;

/**
 * The id of the collection this menu is for
 *
 * @type {number}
 */
FolderMenuView.prototype.collectionId = null;

/**
 * The URL to POST to to deactivate the folder
 *
 * @type {string}
 */
FolderMenuView.prototype.deactivateUrl = null;

/**
 * Toggles the visibility of the menu
 */
FolderMenuView.prototype.toggle = function toggle() {
    this.$menuEl.toggleClass('show');
};

/**
 * Binds various events to the components that comprise this view
 *
 */
FolderMenuView.prototype.bind = function bind() {
    //
    // Expand / Collapse
    //

    this.$menuEl.on(
        'click',
        '.js-menu-title',
        $.proxy(function onMenuTitleClick() {
            this.$menuEl.find('.js-menu-title .cicon').toggleClass('hidden');
            this.$menuEl.find('.js-menu-content').collapse('toggle');
        }, this),
    );

    //
    // Toggle Visibility
    //

    this.$menuTriggerEls.on(
        'click',
        $.proxy(function onMenuTriggerClick(e) {
            e.preventDefault();
            e.stopPropagation();
            this.toggle();
        }, this),
    );

    this.$menuEl.find('a').on('click', (e) => {
        e.stopPropagation(); // prevent from bubbling to document which will close the menu
    });

    //
    // Deactivation Confirmation
    //

    this.$deactivateTriggerEl
        .on('click', (e) => {
            e.preventDefault();
        })
        .popover({
            content: $.proxy(function getDeactivatePopoverContent() {
                const $div = $('<div></div>');
                $div.html($('#js-deactivate-popover-template').html());
                $div.find('.js-deactivate-form').attr({
                    'action': this.deactivateUrl,
                    'data-folder-id': this.collectionId,
                });
                return $div[0].innerHTML;
            }, this),
            html: true,
            placement() {
                return isMaxTablet() ? 'bottom' : 'right';
            },
            trigger: 'focus',
            title: 'Delete', // todo: get from JS context
        });

    //
    // Toggle Visibility Clicking Outside of Menu
    //

    if (isMaxTablet()) {
        $(document.body).on('click', () => {
            $('.js-folder-menu').removeClass('show');
        });
    }
};

export default FolderMenuView;
